import React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRole?: string; // optional role restriction
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRole }) => {
  const location = useLocation();

  // Get access token from localStorage
  const token = localStorage.getItem("accessToken");
  const roleId = localStorage.getItem("role_id");
  // Function to check if token is expired
  const isTokenValid = (): boolean => {
    if (!token) return false;
    try {
      const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT payload
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp > currentTime;
    } catch (error) {
      return false;
    }
  };

  const isValid = isTokenValid();
  // If invalid or expired, redirect to signin
  if (!isValid) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (allowedRole && roleId !== allowedRole) {
    return <Navigate to="/dashboard" replace />;
  }
  // If valid, allow access
  return <>{children}</>;
};

export default ProtectedRoute;
